import Vue from 'vue';
import VueYouTubeEmbed from 'vue-youtube-embed';
export const addYoutubePlugin = () => {
	Vue.use(VueYouTubeEmbed);
};
